import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import {
  formatEurBalanceAsHuf,
  PLAYSTATION_HUF_MAX
} from "../utils/formatEurAsHuf";
import Spinner from "../../components/Spinner";
import {
  MainContainer,
  Navbar,
  Footer,
  Page,
  Heading,
  SubHeading,
  Paragraph,
  ScheduleItem,
  Time,
  ScheduleText,
  ScheduleDay,
  Separator,
  DayLabel,
  NavbarSeparator,
  FondoWrapper,
  FooterImage
} from "./styles";
import logo from "./images/PSTournaments-1.svg";
import digiseqLogo from "./images/digiseq-logo.png";
import paymeSwissLogo from "./images/payme-swiss-logo.svg";
import fondoBg from "./images/fondo-1.svg";
import copyToClipboard from "../../assets/copy-icon-white.svg";

import packageJson from "../../../package.json";

const SCHEDULE = [
  {
    day: "Monday 25th May",
    items: [
      {
        time: "07:30am to 08:00pm",
        text: "Arrival and check in at the Tribe Budapest Stadium Hotel"
      },
      { time: "07:30am to 08:00pm", text: "Free time" }
    ]
  },
  {
    day: "Tuesday 26th May",
    items: [
      { time: "07:30am to 09:30am", text: "Breakfast" },
      { time: "10:15am", text: "Meet in the hotel lobby" },
      {
        time: ["10:20am to", "11:00am"],
        text: "Shuttle transfer to the HungExpo Conference Centre"
      },
      { time: "12:00pm to 01:00pm", text: "Content Filming" },
      { time: "01:00pm to 02:00pm", text: "Lunch time" },
      { time: "02:00pm to 05:00pm", text: "Practice in player lounge" },
      { time: "05:00pm to 07:00pm", text: "Competition" },
      { time: "07:00pm to 08:00pm", text: "Dinner" },
      {
        time: "08:30pm",
        text: "Shuttle transfer to the Tribe Budapest Stadium Hotel"
      }
    ]
  },
  {
    day: "Wednesday 27th May",
    items: [
      { time: "07:30am to 09:30am", text: "Breakfast" },
      { time: ["9:30am to", "03:00pm"], text: "Free time" },
      { time: "04:00pm", text: "Meet in the Hotel lobby" },
      {
        time: "04:15pm to 04:45pm",
        text: "Shuttle transfer to the HungExpo Conference Centre"
      },
      { time: "06:20pm to 09:20pm", text: "eChampions League Final Show" },
      {
        time: "09:30pm",
        text: "Shuttle transfer to the Tribe Budapest Stadium Hotel"
      }
    ]
  },
  {
    day: "Thursday 28th May",
    items: [
      { time: "07:30am to 09:30am", text: "Breakfast" },
      { time: ["09:30am to", "00:00pm"], text: "Free time" }
    ]
  },
  {
    day: "Friday 29th May",
    items: [
      {
        time: "07:30am to 08:00pm",
        text: "Arrival and check in at the Stories Boutique Hotel"
      },
      { time: "07:30am to 08:00pm", text: "Meet in the Hotel lobby" }
    ]
  },
  {
    day: "Saturday 30th May",
    items: [
      { time: "07:30am to 08:00am", text: "Breakfast" },
      { time: ["9:30am to", "3:00pm"], text: "Free time" },
      { time: "03:00pm", text: "Meet in the Hotel lobby" },
      { time: "03:15pm", text: "Shuttle transfer to the Puskas Arena" },
      {
        time: "06:00pm to 08:45pm",
        text: "UEFA Champions League Final & Celebrations"
      },
      { time: ["08:45pm to", "09:15pm"], text: "Shuttle transfer to Hotel" }
    ]
  },
  {
    day: "Sunday 31st May",
    items: [
      { time: "07:30am to 08:00pm", text: "Shuttle transfers to the Airport" }
    ]
  }
];

const renderTime = (time) => {
  if (Array.isArray(time)) {
    return time.map((line) => <p key={line}>{line}</p>);
  }
  return time;
};

const isMultilineTime = (time) => Array.isArray(time);

const Playstation26 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const [showPin, setShowPin] = useState(false);
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;
  return (
    <MainContainer>
      <Navbar>
        <div
          className="navbar-row"
          onClick={() => setShowPin((state) => !state)}
        >
          <img src={logo} alt="PlayStation Tournaments" />
          <div className="balance-container">
            <p className="balance-text">{showPin ? "PIN" : "BALANCE"}</p>
            <p className="balance-value">
              {showPin
                ? balanceAndPin?.pinDetails?.pin || "N/A"
                : formatEurBalanceAsHuf(
                    balanceAndPin?.balanceDetails?.availableBalance,
                    PLAYSTATION_HUF_MAX
                  )}
            </p>
          </div>
        </div>
        <NavbarSeparator />
      </Navbar>

      <Page>
        <Heading>WELCOME TO BUDAPEST!</Heading>
        <Paragraph>
          Your Playstation Tournaments keyring is not just memorabilia from the
          event, it is also a Mastercard contactless card with a daily allowance
          of €80 for your enjoyment.
        </Paragraph>
        <Paragraph>
          To use it simply tap it on any payment terminal just like you would do
          with your everyday card.
        </Paragraph>
        <Paragraph>
          When you return home you have the option to link your own personal
          payment card to your PlayStation Tournaments Keyring and carry on
          using it for contactless payments. You can do this{" "}
          <Link
            className="link"
            target="_blank"
            to={`/curve-account/?serialNumber=${serialNumber}&provider=pannovate`}
          >
            here
          </Link>
          .
        </Paragraph>
        <Separator fullWidth />
        <SubHeading>UEFA CHAMPIONS LEAGUE FINAL</SubHeading>

        {SCHEDULE.map((dayBlock) => (
          <ScheduleDay key={dayBlock.day}>
            <Separator />
            <DayLabel>{dayBlock.day}</DayLabel>
            {dayBlock.items.map((item) => (
              <ScheduleItem
                key={`${dayBlock.day}-${item.text}`}
                $multiline={isMultilineTime(item.time)}
              >
                <Time>{renderTime(item.time)}</Time>
                <ScheduleText>{item.text}</ScheduleText>
              </ScheduleItem>
            ))}
          </ScheduleDay>
        ))}
      </Page>

      <FondoWrapper>
        <FooterImage src={fondoBg} alt="" />
      </FondoWrapper>

      <Footer>
        <div className="powered-by">Powered by</div>
        <img src={digiseqLogo} alt="digiseq-logo" />
        <p className="payment-provider-label">Payment services provided by</p>
        <img
          className="payme-logo"
          src={paymeSwissLogo}
          alt="payme-swiss-logo"
          onClick={() => window.open("https://paymeswiss.com/", "_blank")}
        />
        <div className="footer-links">
          <a
            href="https://digiseq.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://digiseq.co.uk/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
        </div>
        <div className="copyToClipboard">
          <img
            onClick={() => {
              navigator.clipboard.writeText(serialNumber);
              setCopied(true);
            }}
            src={copyToClipboard}
            alt="copy to clipboard"
          />
          <p>ID: {serialNumber}</p>
        </div>
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </Footer>
    </MainContainer>
  );
};

export default Playstation26;
